module.exports = __webpack_public_path__ + "img/20200607_191140.ec1a2f33.jpg";